import { NgModule } from '@angular/core';
import { PackageTypePipe } from './package-type.pipe';
import { ServiceTypePipe } from './service-type.pipe';

@NgModule({
  imports: [],
  declarations: [
    PackageTypePipe,
    ServiceTypePipe,
  ],
  providers: [],
  exports: [
    PackageTypePipe,
    ServiceTypePipe,
  ],
})
export class ShipmentPipesModule {}
